export const ARTICLECHANGED='filter/articleChanged';
export const TITLECHANGED='filter/titleChanged';
export const FILTERBYSEARCH='filter/filterBySearch';